export default "__VITE_ASSET__Cs4S3szr__"